var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 620 420",
    style: {
      enableBackground: "new 0 0 620 420"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.player-pied-0{opacity:0.1;fill:#39003C;enable-background:new    ;}\n\t.player-pied-1{fill:#F17E72;}\n\t.player-pied-2{fill:#D46161;}\n\t.player-pied-3{fill:#FFFFFF;}\n\t.player-pied-4{fill:#E0F0FF;}\n\t.player-pied-5{fill:#FC9E97;}\n\t.player-pied-6{fill:#FDCBC7;}\n\t.player-pied-7{fill:#F0ACAE;}\n\t.player-pied-8{fill:#FFF4F4;}\n\t.player-pied-9{fill:#E49195;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000054955565857051164930000017027439046696919730_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-0",
    points: "168.1,220.8 147.3,231.7 163.4,279.2 259.5,337.8 358.8,384.4 463.9,398.4 528.1,374.5 565.6,306.4  261.5,186.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-1",
    points: "148.6,69.2 143.2,99.4 140,117.4 102.9,148.3 97.9,152.5 71.3,162.8 82.5,106.8 84,104.1  84.1,104.1 89.2,95.1 93.1,88.2 97.5,80.4 105.7,66 106.7,64.7 116.9,51.6 121.4,45.9 141.8,35.1 148.1,46.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1266_00000074412943980231121970000008762410586027346056_",
    className: "player-pied-2",
    d: "M98.4,158.2l-27,4.7l10-60.6 L95.7,85l0,0L88,101.4l6,13.9l-3.3,19.4l12.2,13.6L98.4,158.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1277_00000130621566932226208330000002664345200518504322_",
    className: "player-pied-3",
    d: "M43.3,43.7L29.8,45l-4.5,13L20,73.2 L42.6,88l14.1-7.6l25.1,23.8l6.7-0.3l12.9-11.3l7.6-12.8l1.5-12.4L80.8,47L76,28.3l-15.1-6.9l-6.3,2.4L45,27.5L43.3,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1278_00000088127432954533581660000017106163120260199814_",
    className: "player-pied-4",
    d: "M25.3,57.9L20,73.1L42.6,88 l14.1-7.6l25.1,23.8l6.7-0.3L99.9,94l-12.6,1.3L58.5,73l-20.6,2.4l-10.5-12L25.3,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1279_00000150076578352000332780000011424656919016059838_",
    className: "player-pied-4",
    d: "M45,27.5l-1.7,16.2l6.9,9.5 l-1.9-13.9L52.1,29l2.5-5.2L45,27.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-5",
    points: "148.6,69.2 143.2,99.4 129.8,50.5 116.9,51.6 121.4,45.9 141.8,35.1 148.1,46.6  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-6",
    points: "588.4,307.4 577.4,312.8 578.2,322.2 568.8,332.7 555.6,336.4 556,344.4 544,353.6 528.4,353.5  521.5,366.6 507.5,372.8 494.8,372.7 489.2,381.6 467.6,385.2 434.1,380.2 425.7,379 386,371.5 316,334.5 240.1,295.8 189,273  158.5,230 140.9,196.8 103.4,171.5 71.3,162.8 96.1,144.7 102.8,139.8 133.2,100.6 134.4,95 141.6,61.3 141.8,35.1 208.3,84.7  249.2,100.1 277.9,119.5 344.9,156.9 422.9,203.2 505.6,230.1 555.8,252.1 585,262.9 600.1,284.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-7",
    points: "434.1,380.2 425.7,379 386,371.5 316,334.5 240.1,295.8 189,273 158.5,230 140.9,196.8 103.4,171.5  71.3,162.8 96.1,144.7 151.6,173.7 175.5,217.4 187.2,240.6 235.6,260.2 288.3,301.3 368.1,352.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-8",
    points: "585,262.9 521.9,246.6 446.5,217.3 353.5,187.2 253.8,128.3 187,121.5 137.7,79.4 141.6,61.3  141.8,35.1 208.3,84.7 249.2,100.1 277.9,119.5 344.9,156.9 422.9,203.2 505.6,230.1 555.8,252.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-8",
    points: "577.7,303.7 562.9,292.6 561.8,278.6 568.2,269.4 581.3,268.4 594,278.7 595.4,286.2 586.8,301.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-8",
    points: "511.4,365.7 509.3,358 512.7,351.7 519.7,350.5 524.8,355.2 519.8,364.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-8",
    points: "566.7,328.6 561.4,322.4 561.5,314.8 566.8,311.9 574,313.9 576.1,320.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-8",
    points: "478.4,380.6 482.1,374.1 483.6,367.8 487.6,369.1 491,372.5 487.9,380.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-8",
    points: "542.2,347.7 535.7,342.6 537.6,334.8 542.3,332.2 550.7,336.3 550.7,341.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-9",
    points: "494.8,372.7 484.8,365.5 468.7,352.2 445.1,343.6 441.7,336.8 448.9,336.8 468.3,348.2 484.8,362.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-9",
    points: "528.4,353.5 516,343.9 497.4,331.9 485.1,322.9 474,322.8 494,333.6 506.7,340.9 519.3,347.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-9",
    points: "577.4,312.8 568.9,304.9 548.7,296.3 532.7,287.9 517.6,277.9 504.4,276.7 512.2,282.3 536.1,292.2  549.5,300.5 565.6,306.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-9",
    points: "555.6,336.4 544.3,326.3 528.7,316.5 512.8,309.6 501.5,305 513.2,313.8 529.9,320.7 541.9,328.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-7",
    points: "518.2,368 501.8,367.9 488.8,352.2 467.6,333.8 447.7,329 441.7,336.8 448.9,336.8 468.3,348.2  494.8,372.7 507.5,372.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-7",
    points: "474,322.8 472.3,318.8 480.3,311.2 498.1,321.7 518.5,336.1 527.6,346.3 547.8,350.7 544,353.6  528.4,353.5 516,343.9 497.4,331.9 485.1,322.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "player-pied-7",
    points: "555.6,336.4 544.3,326.3 528.7,316.5 512.8,309.6 501.5,305 498,300.2 512.3,300.3 530.4,308.5  540.7,317.1 554.5,329.8 568.8,332.7  "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_00000150805396537105503820000005214892892020913599_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPied);
export default __webpack_public_path__ + "static/media/pied.7123152dc4d1549b879826f64afd0329.svg";
export { ForwardRef as ReactComponent };